<template>
  <div>
    <div class="listNav">
      <div class="main">
        <i class="home-icon"></i>
        <span>您的位置：</span>
        <span>首页</span>
        <span>></span>
        <span>教材详情</span>
      </div>
    </div>
    <div>
      <div class="main bgmain">
        <div class="detMain">
          <el-row :gutter="50">
            <el-col :span="7">
              <div class="grid-content bg-purple">
                <div class="courseCover">
                  <img class="bookimg" v-lazy="Info.coverUrl" alt />
                </div>
              </div>
            </el-col>
            <el-col :span="17">
              <div class="grid-content bg-purple">
                <div class="title">{{ Info.teachName }}</div>
                <div class="info">
                  <div class="">作者：{{ Info.author }}</div>
                </div>
                <div class="info">
                  <div class="">出版时间：{{ Info.publicationTime }}</div>
                </div>
                <div class="info">
                  <div class="">书 号：{{ Info.isbn }}</div>
                </div>
                <div class="info">
                  <div class="">出 版 社：{{ Info.publicationName }}</div>
                </div>
                <div class="info">
                  <div class="">
                    定 价：<span class="pricetext"
                      >￥{{ Number(Info.pricing).toFixed(2) }}</span
                    >
                  </div>
                </div>
                <div class="operation">
                  <div @click="watchOnline()" class="onLine">在线阅读</div>
                  <!-- <div class="onLine rightspace">下载资源包</div> -->
                  <!-- <div v-if="sampleStatus == 2" class="secondstatus">
                    已审核
                  </div>
                  <div v-else-if="sampleStatus == 1" class="secondstatus">
                    正在审核
                  </div>
                  <div @click="demoApply()" v-else class="secondstatus">
                    {{ isApply == null ? '样书申请' : '已提交' }}
                  </div> -->
                  <!-- <div class="divcard1" @click="joinCart(Info)">
                    <img
                      class="cartimg"
                      src="../../assets/img/car2.png"
                      alt=""
                    />
                    <span>加入选书</span>
                  </div> -->

                  <!-- <div class="divcard1" @click="contactPress(Info)">
                    <span>联系出版社</span>
                  </div> -->
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="detMain">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="简介" name="first">
              <div class="catalog">
                <div class="line"></div>
                <div class="catalogTit">简介</div>
              </div>
              <div
                class="catalogText"
                v-html="Info.textbookSynopsisContent"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="目录" name="three">
              <div class="catalog">
                <div class="line"></div>
                <div class="catalogTit">目录</div>
              </div>
              <div
                v-html="Info.textbookCatalogueContent"
                class="catalogText"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="微课" name="seven">
              <div class="catalog">
                <div class="line"></div>
                <div class="catalogTit">微课</div>
              </div>
              <div v-if="MicroCourseList.length <= 0" class="catalogText">
                无
              </div>
              <div v-else class="defbg">
                <div v-for="(item, index) in MicroCourseList" :key="index">
                  <div class="contents">
                    <div class="contentsTit">{{ item.sectionName }}</div>
                  </div>
                  <div
                    class="convideo"
                    v-for="(sitem, index) in item.smallclassInfoEntityList"
                    :key="index"
                  >
                    <div>{{ sitem.knobbleName }}</div>
                    <div
                      @click="
                        MicroCourse(sitem.knobbleName, sitem.smallclassUrl)
                      "
                    >
                      <img src="../../assets/img/videologo.png" alt />
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              :label="item.typeName"
              :name="item.fid"
              v-for="(item, index) in typeList"
              :key="index"
            >
              <div class="defbg">
                <div class="catalog mt10css">
                  <div class="line"></div>
                  <div class="catalogTit">{{ item.typeName }}</div>
                  <!-- <div
                    class="downloadcss"
                    v-loading="loading"
                    element-loading-text="文件下载中..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.5)"
                    @click="downloadZip(item.fid)"
                  >
                    批量下载
                  </div> -->
                  <!-- <el-button
                    class="downloadcss"
                    @click="downloadZip(item.fid)"
                    type="primary"
                    size="mini"
                    icon="iconfont icon-filedone"
                    :loading="loading"
                  >
                    {{ loading ? '文件下载中...' : '批量下载' }}
                  </el-button> -->
                </div>
                <div
                  class="matItem"
                  v-for="(item, index) in resPackage"
                  :key="index"
                  v-show="showItem"
                >
                  <el-row :gutter="20">
                    <el-col :span="22">
                      <div class="grid-content bg-purple itemImg">
                        {{ item.resourceName }}
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content bg-purple">
                        <div class="itemTit">
                          <div>{{ item.name }}</div>
                          <div
                            @click="resdownload(item.resourceUrl)"
                            class="download"
                          >
                            查看
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div v-show="showmsg" class="message">{{ message }}</div>
                <div class="block">
                  <el-pagination
                    hide-on-single-page
                    layout="prev, pager, next"
                    :total="total"
                  ></el-pagination>
                </div>
              </div>
            </el-tab-pane>

            <!-- <el-tab-pane label="教案" name="second">
              <div class="catalog">
                <div class="line"></div>
                <div class="catalogTit">教案</div>
              </div>
              <div>暂无</div>
              <div v-html="Info.awardsInfo" class="catalogText"></div>
            </el-tab-pane> -->
          </el-tabs>
          <!-- 样书申请 -->
          <el-dialog
            :visible.sync="demodialogVisible"
            width="30%"
            :before-close="handleClose"
            center
          >
            <div class="sample">
              <div>{{ statusText }}</div>
              <div @click="demodialogVisible = false">退出</div>
            </div>
          </el-dialog>
          <el-dialog
            title
            top="30px"
            :visible.sync="matdialogVisible"
            width="40%"
            :before-close="handleClose"
          >
            <div class="matbox">
              <div class="matTip">
                请将以下项目填写完整，更多帮助请咨询：联系电话：15638881604
              </div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                size="small"
                class="demo-ruleForm"
              >
                <el-form-item label="姓名">
                  <el-input v-model="resName" disabled></el-input>
                </el-form-item>
                <el-form-item label="学校">
                  <el-input v-model="resSchName" disabled></el-input>
                </el-form-item>
                <el-form-item label="职称" prop="position">
                  <el-input
                    v-model="professional"
                    placeholder="请输入您的职称"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="手机">
                  <el-input v-model="resPhone" disabled></el-input>
                </el-form-item>
                <el-form-item label="书名">
                  <el-input v-model="Info.teachName" disabled></el-input>
                </el-form-item>
                <el-form-item label="书号(ISBN)">
                  <el-input v-model="Info.isbn" disabled></el-input>
                </el-form-item>
                <el-form-item label="样书数量" prop="stylebookNumber">
                  <el-input
                    v-model="ruleForm.stylebookNumber"
                    placeholder="请输入样书数量"
                  ></el-input>
                </el-form-item>

                <el-form-item label="预计用数量" prop="anticipatedNumber">
                  <el-input
                    v-model="ruleForm.anticipatedNumber"
                    placeholder="请输入预计用数量"
                  ></el-input>
                </el-form-item>

                <el-form-item label="寄送地址" prop="address">
                  <el-input
                    v-model="ruleForm.address"
                    placeholder="请输入您的详细样书寄送地址"
                  ></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="description">
                  <el-input
                    type="textarea"
                    v-model="ruleForm.description"
                    placeholder="请填写您的样书书名-作者（每学期1-2本）"
                    class="textarea"
                  ></el-input>
                </el-form-item>
                <div class="subbut" @click="apply()">提交信息</div>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog
            :title="microTitle"
            :visible.sync="dialogVisible"
            width="700px"
          >
            <div v-if="currentType == 'video'" class="player">
              <video-player
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                style="object-fit: fill"
                :options="playerOptions"
                :x5-video-player-fullscreen="true"
                @pause="onPlayerPause($event)"
                @play="onPlayerPlay($event)"
                @fullscreenchange="onFullscreenChange($event)"
                @click="fullScreen"
                id="video1"
              ></video-player>
            </div>
            <img
              class="fileImage"
              v-if="currentType == 'image'"
              :src="currentFilePath"
              alt=""
            />
          </el-dialog>
        </div>
      </div>
    </div>
    <modelNew @close="close" v-if="showModel"  :pressId="bookId"></modelNew>
    <huiGaoDailog
      @updateVisible="updateVisible"
      :dialogInfo="dialogInfo"
      :visible.sync="dialogVisibleGao"
    ></huiGaoDailog>
  </div>
</template>
<script>
import { Loading } from 'element-ui'
import { getSheetId, fetchApplaySattus, addDemoBook } from '../../api/wapi'
import { hasSemester } from '../../api/index.js'
import { api } from '../../assets/api/axios'
import { getzhichengStr } from '../../assets/tool'
import { mapMutations, mapState, mapGetters } from 'vuex'
import modelNew from '../common/modelNew.vue'
import huiGaoDailog from '../common/huiGaoDialog.vue'
import axios from 'axios'
export default {
  data() {
    return {
      weikeparam: {
        materialId: '',
        pageNo: 1,
        pageSize: 8,
      },
      sheetId: '',
      currentBookData: {},
      activeName: 'first',
      radio: 3,
      getzhichengStr: getzhichengStr,
      matitem: [],
      demodialogVisible: false,
      matdialogVisible: false,
      textarea: '',
      dialogVisible: false,
      playerOptions: {
        //playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4',
            src: 'http://wutonghua-oss.oss-cn-qingdao.aliyuncs.com/jiaofa/onlinechapter/03墙下带形基础.mp4',
          },
        ],
        poster: '',
        width: '',
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          fullscreenToggle: true, //全屏按钮
        },
      },
      ruleForm: {
        pressId: '', //教材ID
        stylebookNumber: '',
        anticipatedNumber: '',
        address: '',
        description: '',
      },
      rules: {
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        teaCourse: [
          { required: true, message: '请输入主授课程', trigger: 'blur' },
        ],
        sampleNum: [
          { required: true, message: '请输入主授课程', trigger: 'blur' },
        ],
        estimateNum: [
          { required: true, message: '请输入预计用书量', trigger: 'blur' },
        ],
        senDarea: [
          { required: true, message: '请输入邮寄地址', trigger: 'blur' },
        ],
      },
      Info: {},
      fid: '',
      catalog: [],
      typeList: [
        { fid: '3', typeName: '电子课件' },
        { fid: '1', typeName: '教案' },
        { fid: '2', typeName: '期末测试' },
      ],
      typeToName: {
        1: '申报材料',
        2: '期末测试',
        3: '电子课件',
      },
      total: 0,
      pageBean: {
        resourceType: '',
        textbookId: '',
      },
      resPackage: [],
      message: '',
      showmsg: false,
      showItem: true,
      MicroCourseList: [],
      microTitle: '',
      enableApply: '',
      sampleStatus: '',
      collectionFlag: 0,
      statusText: '抱歉，由于权限问题，样书申请只限老师账号,请进行教师认证~',
      resbtu: false,
      res: true,
      catalogText: '',
      showModel: false,
      isApply: null,
      dialogVisibleGao: false,
      dialogInfo: null,

      currentType: '',
      currentFilePath: '',
      loading: false,
    }
  },
  watch: {
    dialogVisible: function (val) {
      if (val == false) {
        this.$refs.videoPlayer.player.pause()
      }
    },
  },
  created() {
    this.getInfo()
    let token = localStorage.getItem('Token')
    if (token) {
      this.getApplySta()
    }
    this.professional = getzhichengStr(this.resProfessional)
  },
  computed: {
    ...mapGetters([
      'resPhone',
      'resFid',
      'resStatus',
      'resSchName',
      'resName',
      'resjobNum',
      'restypeFlag',
      'resschType',
      'resProfessional',
      'resBookSelectionAuthority',
    ]),
  },
  components: {
    modelNew,
    huiGaoDailog,
  },
  provide() {
    return {
      updateList: this.updateList,
    }
  },
  methods: {
    // 下载文件
    download(res, resourceType) {
      let blob = new Blob([res.data], { type: 'application/zip' }) //type是文件类，详情可以参阅blob文件类型
      // 创建新的URL并指向File对象或者Blob对象的地址
      const blobURL = window.URL.createObjectURL(blob)
      // 创建a标签，用于跳转至下载链接
      const tempLink = document.createElement('a')
      tempLink.style.display = 'none'
      tempLink.href = blobURL
      let zipName = this.typeToName[resourceType] || ''
      tempLink.download = `${this.Info.teachName}-${zipName}`
      // 挂载a标签
      document.body.appendChild(tempLink)
      tempLink.click()
      document.body.removeChild(tempLink)
      // 释放blob URL地址
      window.URL.revokeObjectURL(blobURL)
    },

    downloadZip(resourceType) {
      let token = localStorage.getItem('Token')
      if (!token) {
        this.$confirm('请先登录后在进行下载', '提示', {
          showClose: true,
          showCancelButton: false,
          showConfirmButton: false,
        })
        return false
      }
      if (this.resPackage && this.resPackage.length > 0) {
        this.loading = true
        axios({
          method: 'POST',
          url: `/teacher/controller/auditstoragepress/bookResourceDownload`,
          data: {
            textbookId: this.$route.query.fid,
            resourceType: resourceType,
          },
          responseType: 'blob', //返回是个文件
        })
          .then((response) => {
            this.loading = false
            this.download(response, resourceType) //then直接下载，方法在下边
          })
          .catch((error) => {
            this.loading = false
          })
      } else {
        this.$message.error('暂无文件可下载')
      }
    },
    // 修改是否让页面显示与隐藏的事件
    updateVisible(val) {
      this.dialogVisibleGao = val
    },
    contactPress(Info) {
      let token = localStorage.getItem('Token')
      if (!token) {
        this.$message.error('请先进行登录')
        return
      }
      this.dialogInfo = Info
      this.dialogVisibleGao = true
    },
    updateList() {},
    getApplyStatusStr(status) {
      var atr = ''
      switch (status) {
        case 1:
          str = '待处理'
          break
        case 2:
          str = '已处理'
          break
        case 3:
          str = '已拒绝'
          break
        default:
          break
      }
    },
    getApplySta() {
      fetchApplaySattus({
        pressId: this.fid,
      })
        .then((result) => {
          if (result && result.data) {
            var data = result.data
            this.isApply = true
          } else {
            this.isApply = null
          }
        })
        .catch((err) => {})
    },
    // 判断是否有可用的选书清单
    visableSheetInfo(matData) {
      let loadingInstance = Loading.service({ background: 'rgba(0,0,0,0.5)' })
      getSheetId()
        .then((result) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
          if (result.data) {
            var data = result.data[0]
            this.sheetId = data.fid
            matData.sheetId = this.sheetId
            matData.materialId = matData.fid
            this.showModel = true
            this.currentBookData = matData
          } else {
            this.$confirm('暂无可供选书的清单，无法进行选书', '提示', {
              showClose: true,
              showCancelButton: false,
              showConfirmButton: false,
            })
          }
        })
        .catch((err) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        })
    },
    // 加入选书
    joinCart(data) {
      let token = localStorage.getItem('Token')
      if (!token) {
        this.$confirm('请先登录再进行操作', '提示', {
          showClose: true,
          showCancelButton: false,
          showConfirmButton: false,
        })
        return
      }
      if (this.resBookSelectionAuthority != 1) {
        this.$message.error('您没有选书资格')
        return
      }
      this.bookId = data.id
      this.showModel = true
  
    },
    close() {
      this.showModel = false
    },
    async getInfo() {
      let fid = this.$route.query.fid
      this.fid = fid
      let res = await api.get(
        '/teacher/controller/auditstoragepress/bookInfo/' +
          fid +
          `?userId=${this.resFid}`
      )
      this.Info = res.data
    },
    async getTest() {
      let res = await api.post('/front/teamaterial/lookCatalog', {
        fid: this.fid,
      })
      this.catalog = res.data
    },
    async getResPackage(typeId) {
      this.pageBean.textbookId = this.fid
      this.pageBean.resourceType = typeId
      let res = await api.post(
        `/teacher/controller/auditstoragepress/bookResource?textbookId`,
        {
          textbookId: this.pageBean.textbookId,
          resourceType: this.pageBean.resourceType,
        }
      )
      if (res.status == 0) {
        this.showItem = true
        this.showmsg = false
        this.resPackage = res.data
        this.total = res.data.total
      }
      if (res.status != 0) {
        this.message = res.msg
        this.showmsg = true
        this.showItem = false
      }
    },
    async resdownload(downurl) {
      // const a = document.createElement('a')
      // const url = downurl
      // fetch(url)
      //   .then((res) => res.blob())
      //   .then((blob) => {
      //     a.href = URL.createObjectURL(blob)
      //     a.download = ''
      //     document.body.appendChild(a)
      //     a.click()
      //   })
      if (downurl) {
        window.open(downurl)
      } else {
        this.$message.info('未发现资源链接')
      }
    },
    async getMicroCourseList() {
      let res = await api.post(
        `/teacher/controller/auditstoragepress/smallclassInfoAllList`,
        { textbookId: this.fid }
      )
      if (res.status == 0) {
        this.MicroCourseList = res.data
      }
    },
    MicroCourse(fileName, filePath) {
      if (filePath.indexOf('.mp4') != -1) {
        this.microTitle = fileName
        this.playerOptions.sources[0].src = filePath
        this.dialogVisible = true
        this.currentType = 'video'
      } else {
        this.dialogVisible = true
        this.currentType = 'image'
        this.currentFilePath = filePath
      }
      console.log('filePath===>', filePath, this.currentType)
    },
    watchOnline() {
      if (!this.Info.electronicPressUrl) {
        this.$message({
          message: '暂时没有资源可以查看哦',
          type: 'warning',
        })
        return
      }
      this.Info.electronicPressUrl && window.open(this.Info.electronicPressUrl)
    },
    demoApply() {
      if (this.isApply == null) {
        this.matdialogVisible = true
      }
      // this.demodialogVisible = true
      // if (localStorage.getItem('Token')) {
      //   let params = {
      //     platformId: '',
      //     teacherId: '',
      //     pressId: '',
      //     stylebookNumber: '',
      //     anticipatedNumber: '',
      //     address: '',
      //     description: '',
      //   }
      //   api
      //     .post(
      //       `/teacher/controller/stylebookapplyinfo/save/${this.fid}`,
      //       params
      //     )
      //     .then((res) => {
      //       if (res.status == 0) {
      //         if (res.data.enableApply == 1) {
      //           this.demodialogVisible = true
      //           this.statusText = '已申请不能重复申请!'
      //         }
      //       }
      //     })
      //     .catch(() => {})
      // } else {
      //   this.$message.error('请先登录')
      // }
    },
    apply() {
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          this.ruleForm.pressId = this.fid
          let res = await addDemoBook(this.ruleForm)
          if (res.status == 0) {
            this.$message.success('提交成功')
            this.matdialogVisible = false
            this.$nextTick(() => {
              this.isApply = true
            })
          } else {
            this.$message.error('提交失败，请重新提交')
          }
        } else {
          return false
        }
      })
    },
    matdown() {
      if (this.restypeFlag == 1 && this.schType == 0) {
        let teamatId = this.fid
        window.location.href = `http://192.168.1.106:8086/front/teamaterial/resPackageDownload?teamatId=${teamatId}`
      } else if (this.schType == 0) {
        this.$message.warning('没有权限，您是非合作院校老师')
      } else if (this.restypeFlag == 1) {
        this.$message.warning('没有权限，您不是老师账号，请进行教师认证')
      } else {
        this.$message.warning('没有权限')
      }
    },
    // 开始测试
    test(fid) {
      this.$router.push({
        path: '/teachingmat/Matdetails/chaptertest',
        query: { fid: 'a5ab8744-3443-4e4d-b31e-27e763b6d96d' },
      })
    },
    handleClick(tab, event) {
      if (this.activeName == 'second') {
      } else if (this.activeName == 'first') {
      } else if (this.activeName == 'seven') {
        this.getMicroCourseList()
      } else if (this.activeName == 'three') {
      } else {
        this.getResPackage(this.activeName)
      }
    },
    handleClose(done) {
      this.demodialogVisible = false
      this.matdialogVisible = false
    },
    // 视频方法
    fullScreen() {
      const player = this.$refs.videoPlayer.player
      player.requestFullscreen() //调用全屏api方法
      player.isFullscreen(true)
      player.play()
    },
    onPlayerPlay(player) {
      player.play()
    },
    onPlayerPause(player) {},
    // 表单验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
.mt10css {
  margin-top: 10px !important;
}
.fileImage {
  width: 100%;
  // max-height: 700px;
  object-fit: contain;
}
.el-form-item {
  margin-bottom: 15px;
}
.detBg[data-v-7c66a6a2] {
  background-color: #f8f8f8;
}
.defbg {
  // min-height: 300px;
}
.bookimg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.cartimg {
  width: 20px;
  height: 19px;
  display: inline-block;
  vertical-align: middle;
  margin-top: -2px;
  margin-right: 5px;
}
.divcard1 {
  width: 120px;
  height: 38px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  line-height: 38px;
  text-align: center;
  float: left;
  margin-left: 10px;
  cursor: pointer;
}
.pricetext {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #b80d03;
}
.nav {
  width: 100%;
  height: 42px;
  background: rgba(237, 234, 231, 1);
}
.main {
  // min-height: 100px;
  overflow-y: scroll;
}
.bgmain {
  background: #fff;
  min-height: 900px;
  overflow-y: scroll;
}
.detMain {
  margin: 0 120px 0;
  padding-top: 30px;
}
.courseCover {
  height: 320px;
  width: 226px;
  img {
    width: 100%;
    height: 100%;
  }
}
.rightspace {
  margin-left: 10px;
}
.star {
  margin-top: 10px;
  height: 38px;
  border: 1px solid rgba(224, 224, 224, 1);
  width: 100%;
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  line-height: 40px;
  text-align: center;
}
.title {
  color: rgba(0, 0, 0, 1);
  margin: 22px 0 8px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #000000;
  line-height: 24px;
}
.info {
  overflow: hidden;
  height: 36px;
  line-height: 36px;
  div {
    font-size: 14px;
    color: #666666;
  }
  .left {
    float: left;
    width: 330px;
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
  }
  .right {
    float: left;
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
  }
}
.link {
  width: 100%;
  min-height: 40px;
  background: rgba(245, 245, 245, 1);
  margin-top: 20px;
  line-height: 40px;
  padding-left: 10px;
  overflow: hidden;
  div:nth-child(1) {
    font-size: 14px;
    color: rgba(153, 153, 153, 1);
    float: left;
  }
  div:nth-child(2) {
    // width: 100px;
    font-size: 14px;
    color: rgba(211, 111, 22, 1);
    float: left;
  }
}
.tip {
  margin: 10px 0 25px;
  font-size: 13px;
  color: rgba(204, 204, 204, 1);
}
.onLine {
  float: left;
  width: 120px;
  height: 40px;
  background: #0082f0;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.downloadcss {
  float: right;
}
.secondstatus {
  float: left;
  width: 120px;
  height: 40px;
  background: rgba(221, 221, 221, 1);
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}
.operation {
  overflow: hidden;
  margin-top: 40px;
}
.catalog {
  overflow: hidden;
  margin: 0px 0;
  .line {
    width: 3px;
    height: 14px;
    background: #0082f0;
    float: left;
  }
  .catalogTit {
    font-size: 14px;
    font-weight: 500;
    color: #0082f0;
    margin-left: 8px;
  }
}
.catalogText {
  font-size: 13px !important;
  // min-height: 300px;
}
.catalogText,
.catalogText p,
.catalogText p span {
  margin: 10px 0 60px !important;
  font-size: 13px !important;
  font-weight: 400;
  line-height: 28px;
}
.catalog .line {
  width: 6px;
}
.contents {
  overflow: hidden;
  .contentsTit {
    margin: 30px 0 20px;
    float: left;
    font-size: 16px;
    font-family: SourceHanSansCN;
    font-weight: 700;
    color: rgba(102, 102, 102, 1);
  }
  .btn {
    float: right;
    width: 82px;
    height: 30px;
    border: 1px solid rgba(224, 224, 224, 1);
    color: rgba(102, 102, 102, 1);
    background-color: none;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    &:hover {
      color: #0082f0;
    }
  }
}
.contentsInfo {
  div {
    font-size: 13px;
    color: rgba(102, 102, 102, 1);
    line-height: 35px;
  }
}
.convideo {
  height: 35px;
  overflow: hidden;
  div:nth-child(1) {
    font-size: 13px;
    color: rgba(102, 102, 102, 1);
    float: left;
  }
  div:nth-child(2) {
    float: right;
  }
}
.matNav {
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  display: float;
  margin-top: 20px;
  overflow: hidden;
  height: 70px;
  line-height: 40px;
  div {
    float: left;
  }
  .signUp {
    position: relative;
  }
  .iconTop {
    position: absolute;
    top: 9px;
    right: -15px;
    &:hover {
      color: #0b3450;
    }
  }
  .iconBot {
    position: absolute;
    bottom: 9px;
    right: -15px;
    &:hover {
      color: #0b3450;
    }
  }
  .dataTime {
    position: relative;
    margin-right: 30px;
  }
  .search {
    width: 190px;
    height: 34px;
    margin-right: 20px;
    input {
      border: none;
      background: rgba(0, 0, 0, 0.1);
      width: 190px;
      height: 34px;
      padding-left: 10px;
    }
  }
  .searchBut {
    width: 77px;
    height: 34px;
    background: #0082f0;
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
    line-height: 34px;
    text-align: center;
    float: right;
    margin-top: 4px;
  }
}
.uploadMat {
  overflow: hidden;
  :nth-child(1) {
    float: left;
    width: 180px;
    height: 42px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(224, 224, 224, 1);
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 42px;
    text-align: center;
  }
  :nth-child(2) {
    float: left;
    height: 42px;
    line-height: 42px;
    color: rgba(153, 153, 153, 1);
    font-size: 12px;
    margin-left: 20px;
  }
}
.matItem {
  margin-top: 16px;
  border-bottom: 1px dashed #e0e0e0;
  .itemImg {
    width: 100%;
    font-size: 14px;
    color: #333;
    line-height: 16px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .itemTit {
    overflow: hidden;
    margin: 0px;
    .download {
      font-size: 14px;
      line-height: 16px;
      margin-bottom: 16px;
    }
    :nth-child(1) {
      float: left;
      font-size: 14px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    :nth-child(2) {
      float: right;
      font-size: 13px;
      color: #a51109;
      cursor: pointer;
    }
  }
  .itemInfo {
    font-size: 13px;
    color: rgba(102, 102, 102, 1);
    line-height: 24px;
  }
}
.sample {
  :nth-child(1) {
    margin: 0 auto;
    text-align: center;
    margin-bottom: 60px;
  }
  :nth-child(2) {
    margin: 0 auto;
    height: 36px;
    background: #0082f0;
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 36px;
    text-align: center;
    margin-bottom: 40px;
  }
}
.matbox {
  margin: 0 30px;
  .matTip {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    // margin-bottom: 20px;
    margin: 0 0 20px 30px;
  }
  .userInfo {
    overflow: hidden;
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    .InfotTit {
      float: left;
      line-height: 40px;
    }
    input {
      float: left;
      width: 496px;
      height: 40px;
      border: 1px solid rgba(237, 237, 237, 1);
      padding-left: 15px;
      margin-bottom: 10px;
      &::placeholder {
        font-size: 14px;
        color: rgba(204, 204, 204, 1);
      }
    }
  }
  .message {
    overflow: 'hidden';
    height: 160px;
    :nth-child(1) {
      float: left;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
    }
    :nth-child(2) {
      float: left;
    }
  }
  .subbut {
    height: 36px;
    background: #0082f0;
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    line-height: 36px;
    margin: 20px 0 20px;
  }
}
.message {
  font-size: 18px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 24px;
  margin: 40px 40px 200px;
}
</style>
<style lang="scss">
@import '../../assets/css/mattabs.scss';
.catalogItem {
  line-height: 30px;
  margin: 10px 0 60px;
}
</style>
<style >
.detMain .textarea textarea {
  width: 100% !important;
}
.detMain .el-tabs__nav-scroll {
  height: 42px;
  background: #f8f8f8;
  border: 1px solid #e6e6e6;
}

.detMain .el-tabs__item {
  height: 44px;
  background: none;
  border: 0;
  line-height: 44px;
}
.detMain .el-tabs__item .is-active {
  color: #ffffff !important;
  border-top: 0;
  background-color: #0082f0;
}
.el-tabs__item:hover {
  color: #0082f0 !important;
}
.detMain #tab-first {
  border-left: 0px;
}
.el-tabs__nav-wrap::after {
  height: 0px !important;
}
.el-tabs__header {
  margin: 0 !important;
}
</style>
